<template>
    <div>
        <h1 class="card-title h5">{{$t( 'common.dear_guest' )}}</h1>
        <p class="card-text">
            {{$t( 'bookingServiceSuccess.supporting_text.common.success_message.text' )}}
            {{$t( 'bookingServiceSuccess.supporting_text.common.additional_information.text' )}}
        </p>
        <p class="card-text" v-if="singleDateSelection">
            {{$t( 'bookingServiceSuccess.supporting_text.singledate_selection.next_step.text' )}}
        </p>
        <p class="card-text" v-else-if="isHotelBooking">
            {{$t( 'bookingServiceSuccess.supporting_text.no_animod_booking_service.next_step.text', {'hotel': activationData.arrangement.hotelname} )}}
        </p>
        <p class="card-text" v-else-if="isAnimodBooking">
            {{$t( 'bookingServiceSuccess.supporting_text.use_animod_booking_service.next_step.text' )}}
        </p>
        <i18n path="bookingServiceSuccess.supporting_text.common.customer_support.text" tag="p" class="card-text">
            <CustomerServiceEmail/>
            <CustomerServicePhone/>
        </i18n>
            <div class="card-navigation">
                <button class="btn btn-secondary" @click="$store.dispatch('reset')">
                    {{$t('common.redeem_another_voucher' )}}
                </button>
            </div>
    </div>
</template>

<script>
    import CustomerServiceEmail from "../components/CustomerServiceEmail";
    import CustomerServicePhone from "../components/CustomerServicePhone";
    import { mapGetters, mapState } from 'vuex';

    export default {
        name: 'BookingServiceSuccessView',
        components: {CustomerServiceEmail, CustomerServicePhone},
        computed: {
            ...mapState(['voucher', 'activationData']),
            ...mapGetters([ 'isHotelBooking', 'isAnimodBooking', 'singleDateSelection' ])
        }
    }
</script>

